import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import Icon from "../../components/Icon/Icon";
import UserHeader from "./UserHeader/UserHeader";
import { Toggle } from "../Sidebar/Sidebar";
import { convertRoleToPath } from "../../utils";
import BackToAdmin from "../BackToAdmin/BackToAdmin";

const Header = ({ fixed, sidebarToggle, setVisibility }) => {
  const meta = useSelector((state) => state.meta);
  const auth = useSelector((state) => state.auth);

  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
  });

  return (
    <div className={headerClass}>
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ml-n1">
            <Toggle
              className="nk-nav-toggle nk-quick-nav-icon"
              icon="menu"
              click={sidebarToggle}
            />
          </div>
          <div className="nk-header-brand d-xl-none">
            <Link to="/" className="logo-link">
              <img
                className="logo-light logo-img"
                src="/assets/images/logo2x.png"
                alt="logo"
              />
              <img
                className="logo-dark logo-img"
                src="/assets/images/logo-dark2x.png"
                alt="logo"
              />
            </Link>
          </div>
          <BackToAdmin />
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <li
                className="user-dropdown"
                onClick={() => setVisibility(false)}
              >
                <UserHeader />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
